import { createRootRouteWithContext, redirect } from "@tanstack/react-router";
import { ErrorBoundary } from "components/ErrorBoundary";
import { NotFound } from "components/NotFound";
import { RootProvider } from "providers/Root";
import { resolveAlias } from "../aliases";
import type { RouterContext } from "../context";

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  beforeLoad: ({ location }) => {
    const aliased = resolveAlias(location.pathname);
    if (aliased) throw redirect({ href: `${aliased}${location.searchStr}`, replace: true });
  },
  component: RootProvider,
  errorComponent: ErrorBoundary,
  notFoundComponent: NotFound,
});
